import { isValid, parse } from 'date-fns'

const isDate = maybeValidDate => isValid(parse(maybeValidDate))

export default isDate
